import axios from 'axios';
import env from '../Utils/env';
import localStorage from "redux-persist/lib/storage";


// Crée une instance Axios
const api = axios.create({
  baseURL: env.baseURL, 
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(async (config) => {
  const token = await localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Fonction pour mettre à jour le profil
export const updateProfile = async (userData) => {
    
  return await api.put('/profile', userData);
};

